<template>
    <div>
        <v-chart :options="options"/>
    </div>
</template>
<style>
.echarts {
  width: 300px;
  height: 300px;
}
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'
import util from '../utilitarios/util.js'

export default {
    name : "cmpgraficodoughnut",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'rotulo',
        'legendas',
			'dados'
    ],
    computed:{
        temaSistema(){
            return this.$store.state.temasistema;
        },
        options(){
            return {
                color: util.gerarpaletagrafico(this.temaSistema, 11),
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: -5,
                    top: '30',
                    data: this.legendas || [],
                    textStyle: {
							fontSize: 8
						}
                },
                series: [
                    {
                        name: this.rotulo || '',
                        type: 'pie',
                        radius: ['35%', '65%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '14',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.dados || []
                    }
                ]
            };
        }
    }    
}
</script>
